import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const BookingApproval = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [gridData, setGridData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const totalPages = Math.ceil(gridData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = gridData.slice(startIndex, startIndex + pageSize);

  useEffect(() => {
    fetchApprovalGrid();
  }, []);

  const fetchApprovalGrid = async () => {
    try {
      const response = await apiFetch(
        "/api/booking/approvalgrid",
        { method: "POST", body: JSON.stringify({}) },
      );
      const data = await response.json();
      setGridData(Array.isArray(data) ? data : data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleSearch = async () => {
    try {
      const response = await apiFetch(
        "/api/booking/searchadmin",
        { method: "POST", body: JSON.stringify({ search: searchText }) },
      );
      const data = await response.json();
      setGridData(Array.isArray(data) ? data : data.data || []);
      setCurrentPage(1);
    } catch (err) {
      console.error("Search error:", err);
    }
  };

  const filteredData = paginatedData.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(searchText.toLowerCase()),
  );
  const handleApprove = async () => {
    try {
      const response = await apiFetch(
        "/api/booking/approvedata",
        { method: "POST", body: JSON.stringify({ bo_12: selectedBooking.BO_12 }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Approved successfully");
        setShowModal(false);
        fetchApprovalGrid();
      } else {
        alert(data.err);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleReject = async () => {
    try {
      const response = await apiFetch(
        "/api/booking/rejectdata",
        { method: "POST", body: JSON.stringify({ bo_12: selectedBooking.BO_12 }) },
      );
      const data = await response.json();
      if (data.err === "0") {
        alert("Rejected successfully");
        setShowModal(false);
        fetchApprovalGrid();
      } else {
        alert(data.err);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Layout>
      <div className="page">
        <div className="box">
          <div className="topBar">
            <h3>Manager Booking Approval</h3>

            <div className="controls">
              <input
                className="searchInput"
                placeholder="Search..."
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />

              <button className="searchBtn" onClick={handleSearch}>
                Search
              </button>

              <select
                className="pageSelect"
                value={pageSize}
                onChange={(e) => {
                  setPageSize(Number(e.target.value));
                  setCurrentPage(1);
                }}
              >
                {[10, 20, 50, 100].map((n) => (
                  <option key={n}>{n} / page</option>
                ))}
              </select>
            </div>
          </div>

          <div className="tableWrap">
            <table>
              <thead>
                <tr>
                  <th>Booking Date</th>
                  <th>Customer</th>
                  <th>Model</th>
                  <th>Variant</th>
                  <th>Color</th>
                  <th>Price</th>
                  <th>Delivery</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {filteredData.length ? (
                  filteredData.map((row, i) => (
                    <tr key={i}>
                      <td>{row.date}</td>
                      <td>{row.bo_23}</td>
                      <td>{row.bo_26}</td>
                      <td>{row.bo_27}</td>
                      <td>{row.bo_28}</td>
                      <td>{row.BO_35}</td>
                      <td>{row.bo_32}</td>
                      <td>{row.status}</td>
                      <td>
                        <button
                          className="editBtn"
                          onClick={() => {
                            setSelectedBooking(row);
                            setShowModal(true);
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="empty">
                      No records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <div className="pager">
            <button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            >
              Prev
            </button>

            <span>
              {currentPage} / {totalPages || 1}
            </span>

            <button
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => p + 1)}
            >
              Next
            </button>
          </div>
        </div>

        {/* ===== RESPONSIVE CSS ===== */}
        <style>{`
.page{
  padding:12px;
  background:#f4f6f8;
  min-height:100vh;
}

.box{
  background:#fff;
  padding:16px;
  border-radius:8px;
  box-shadow:0 3px 8px rgba(0,0,0,.08);
}

/* ===== TOP BAR ===== */
.topBar{
  display:flex;
  flex-wrap:wrap;
  gap:12px;
  justify-content:space-between;
  align-items:center;
  margin-bottom:14px;
}

.controls{
  display:flex;
  align-items:center;
  gap:8px;
  width:100%;
  max-width:700px;
}

/* ===== SEARCH INPUT ===== */
.searchInput{
  flex:1;
  padding:9px 12px;
  border:1px solid #ccc;
  border-radius:4px;
  min-width:220px;
  font-size:14px;
}

.searchInput:focus{
  outline:none;
  border-color:#2196F3;
  box-shadow:0 0 0 2px rgba(33,150,243,.1);
}

/* ===== SEARCH BUTTON ===== */
.searchBtn{
  background:#2196F3;
  color:#fff;
  border:none;
  padding:9px 16px;
  border-radius:4px;
  cursor:pointer;
  font-size:14px;
  font-weight:500;
  transition:.2s;
}

.searchBtn:hover{
  background:#1976D2;
}

/* ===== PAGE SIZE DROPDOWN ===== */
.pageSelect{
  padding:9px 10px;
  border:1px solid #ccc;
  border-radius:4px;
  min-width:110px;
  font-size:14px;
}

/* ===== TABLE ===== */
.tableWrap{
  width:100%;
  overflow-x:auto;
}

table{
  width:100%;
  border-collapse:collapse;
  min-width:900px;
}

th{
  background:#8B1E3F;
  color:#fff;
  padding:10px;
  font-size:14px;
  white-space:nowrap;
}

td{
  padding:8px;
  border:1px solid #ddd;
  font-size:13px;
  text-align:center;
  white-space:nowrap;
}

/* ===== ACTION BUTTON ===== */
.editBtn{
  background:#4CAF50;
  border:none;
  padding:6px 12px;
  color:#fff;
  border-radius:4px;
  cursor:pointer;
  transition:.2s;
}

.editBtn:hover{
  background:#43a047;
}

/* ===== PAGINATION ===== */
.pager{
  margin-top:14px;
  display:flex;
  justify-content:center;
  align-items:center;
  gap:12px;
}

.pager button{
  padding:6px 14px;
  border:1px solid #ccc;
  background:#f9f9f9;
  cursor:pointer;
  border-radius:4px;
  transition:.2s;
}

.pager button:hover:not(:disabled){
  background:#eee;
}

.pager button:disabled{
  opacity:.6;
  cursor:not-allowed;
}

.empty{
  text-align:center;
  padding:15px;
}

/* ===== RESPONSIVE ===== */

@media(max-width:768px){
  .controls{
    flex-wrap:wrap;
    max-width:100%;
  }

  .searchInput{
    min-width:100%;
  }

  .searchBtn{
    width:100%;
  }

  .pageSelect{
    width:100%;
  }
}

@media(max-width:480px){
  h3{font-size:16px}
  td,th{font-size:12px}
}

@media(min-width:769px) and (max-width:1024px){
  table{min-width:1000px}
}
 /* OVERLAY */
.modalOverlay{
  position:fixed;
  inset:0;
  background:rgba(0,0,0,.6);
  display:flex;
  justify-content:center;
  align-items:center;
  z-index:9999;
}

/* MODAL BOX */
.bookingModal{
  width:95%;
  max-width:1100px;
  background:#fff;
  border-radius:6px;
  overflow:hidden;
}

/* HEADER */
.modalHeader{
  background:#8B1E3F;
  color:white;
  padding:12px 16px;
  font-size:18px;
  font-weight:600;
  display:flex;
  justify-content:space-between;
  align-items:center;
}

.closeX{
  cursor:pointer;
  font-size:18px;
}

/* BODY */
.modalBody{
  padding:16px;
}

/* GRID – 3 COLUMNS */
.formGrid{
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:12px;
}

.formGrid div{
  display:flex;
  flex-direction:column;
}

label{
  font-size:13px;
  font-weight:600;
  margin-bottom:3px;
}

input, textarea{
  padding:7px;
  border:1px solid #ccc;
  border-radius:4px;
  font-size:13px;
  background:#f5f5f5;
}

/* STATUS */
.statusBox{
  grid-column:span 1;
}

.statusInput{
  background:yellow;
  font-weight:700;
}

/* REMARK */
.remarkRow{
  margin-top:12px;
  display:flex;
  flex-direction:column;
}

textarea{
  min-height:70px;
  resize:none;
}

/* FOOTER */
.modalFooter{
  display:flex;
  justify-content:center;
  align-items:center;
  flex-wrap:wrap;
  gap:12px;
  padding:16px;
}

/* BUTTON COLORS */
.approveBtn,
.rejectBtn,
.closeBtn {
  min-height: 44px;
  min-width: 100px;
  padding: 10px 22px;
  border: none;
  border-radius: 6px;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  touch-action: manipulation;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.2s;
  white-space: nowrap;
  box-sizing: border-box;
}

.approveBtn{
  background:#2e7d32;
  color:white;
}
.approveBtn:hover { background:#1b5e20; }

.rejectBtn{
  background:#e53935;
  color:white;
}
.rejectBtn:hover { background:#c62828; }

.closeBtn{
  background:#ef5350;
  color:white;
}
.closeBtn:hover { background:#c62828; }

/* ================= RESPONSIVE ================= */

/* Large tablets */
@media(max-width:1024px){
  .formGrid{
    grid-template-columns:repeat(2,1fr);
  }
}

/* Mobile */
@media(max-width:600px){
  .formGrid{
    grid-template-columns:1fr;
  }

  .modalFooter{
    flex-direction:column;
    align-items:stretch;
    padding:12px 16px;
  }

  .modalFooter button,
  .approveBtn,
  .rejectBtn,
  .closeBtn {
    width:100%;
    text-align:center;
    font-size:15px;
    padding:12px 16px;
  }
}

/* Extra small */
@media(max-width:400px){
  .modalHeader{
    font-size:16px;
  }
  .approveBtn,
  .rejectBtn,
  .closeBtn {
    font-size:14px;
    padding:11px 12px;
  }
}
.readonlyInput{
  background:#f1f1f1;
  color:#444;
  cursor:not-allowed;
}


`}</style>
      </div>
      {showModal && (
        <div className="modalOverlay">
          <div className="bookingModal">
            {/* HEADER */}
            <div className="modalHeader">
              Booking Details
              <span className="closeX" onClick={() => setShowModal(false)}>
                ✖
              </span>
            </div>

            {/* BODY */}
            <div className="modalBody">
              <div className="formGrid">
                <div>
                  <label>Customer Name</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_23}
                    readOnly
                  />
                </div>
                <div>
                  <label>Model</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_26}
                    readOnly
                  />
                </div>
                <div>
                  <label>Color</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_28}
                    readOnly
                  />
                </div>

                <div>
                  <label>Sales Consultant</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_20}
                    readOnly
                  />
                </div>
                <div>
                  <label>Variant</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_27}
                    readOnly
                  />
                </div>
                <div>
                  <label>Package Price</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.BO_35}
                    readOnly
                  />
                </div>

                <div>
                  <label>Delivery Date</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.bo_32}
                    readOnly
                  />
                </div>

                <div className="statusBox">
                  <label>Status</label>
                  <input
                    className="readonlyInput"
                    value={selectedBooking.status}
                    readOnly
                  />
                </div>
              </div>
              <div className="remarkRow">
                <label>TL Remark</label>
                <textarea
                  className="readonlyInput"
                  value={selectedBooking?.tl_remark || ""}
                  readOnly
                />
              </div>

              <div className="remarkRow">
                <label>Remark</label>
                <textarea />
              </div>
            </div>

            {/* FOOTER BUTTONS */}
            <div className="modalFooter">
              <button className="approveBtn" onClick={handleApprove}>
                Approve
              </button>

              <button className="rejectBtn" onClick={handleReject}>
                Reject
              </button>

              <button className="closeBtn" onClick={() => setShowModal(false)}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default BookingApproval;
